import styled from 'styled-components';
import { SideNavColorSchemeProps, SideNavColorSchemeIndex } from '../..';
import { localTheme } from '../../../../styles/local-theme';

const bgSeperatorColorScheme: SideNavColorSchemeIndex = {
  dark: localTheme.colors.slateGray,
  blue: localTheme.colors.marinoBlue,
};

const SubCategorySection = styled.div<SideNavColorSchemeProps>`
  width: 100%;
  padding: ${(props): string => props.theme.spaces.lg};
  padding-bottom: 0;

  &::after {
    content: '';
    display: block;
    height: ${(props): string => props.theme.spaces.md};
    border-bottom: solid 1px
      ${(props): string => bgSeperatorColorScheme[props.colorScheme]};
  }

  &:last-child {
    padding-bottom: ${(props): string => props.theme.spaces.lg};

    &::after {
      display: none;
    }
  }

  // Disable dropping effect on this list
  .subCategoryItemDraggingPlaceholder ~ .subCategoryItem {
    transform: none !important;
  }
  .draggingPlaceholder {
    display: none;
  }
`;

export { SubCategorySection };
